import {
	ConditionalNode,
	EmailNode,
	LinkedinInmailNode,
	LinkedinInviteNode,
	LinkedinNode,
	LinkedinRemoveInviteNode,
	StarterNode,
} from "../components/nodes";
import { LinkedinVisitNode } from "../components/nodes/LinkedinVisitNode";

export const nodeTypes = {
	starterNode: StarterNode,
	emailNode: EmailNode,
	conditionalNode: ConditionalNode,
	linkedinNode: LinkedinNode,
	linkedinInviteNode: LinkedinInviteNode,
	linkedinVisitNode: LinkedinVisitNode,
	linkedinRemoveInviteNode: LinkedinRemoveInviteNode,
	linkedinInmailNode: LinkedinInmailNode,
};

export type CampaignNodeTypes =
	| "starterNode"
	| "emailNode"
	| "conditionalNode"
	| "linkedinNode"
	| "linkedinInviteNode"
	| "linkedinVisitNode"
	| "linkedinRemoveInviteNode"
	| "linkedinInmailNode";

export interface handleAddStepProps {
	position: { x: number; y: number };
	initiatorId: string;
	edgeType: "yesEdge" | "noEdge" | "normalEdge";
	nodeType: CampaignNodeTypes;
	hasNextNode: boolean;
	hasNextYesNode?: boolean;
	hasNextNoNode?: boolean;
}
